<template>
	<div id="app">
		<div v-html="rootStyle"></div>
		<router-view v-if="ready || $route.name === 'ErrorPage' || isStandAlone"/>
	</div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import Rest from "@/api/Rest";
import axios from "axios";
import AppConfig from "@/classes/AppConfig";
import {merge} from "lodash";

export default {
	data() {
		return {
			ready: false
		}
	},
	computed: {
		...mapGetters('landingPage', ['currentFlyer']),
		...mapState('landingPage', ['flyers']),
		...mapState('storeLocator', ['closestStores']),
		...mapGetters('storeLocator', ['storeLocatorEnabled']),
		...mapGetters('config',['rootStyle']),
		isStandAlone() {
			return this.$route?.meta?.standalone;
		},
	},
	methods: {
		...mapActions('landingPage', ['getFlyersData', 'setCurrentFlyer']),
		...mapActions(['setLanguage', 'setPages', 'setCurrentStore', 'setCurrentStoreObj']),
		...mapActions('storeLocator', ['fetchFiveClosestStores', 'setCurrentLocation']),
		...mapActions('screen', ['handleWindowResize']),

		async fetchStoreFromQueryParamStoreId(storeId) {
			const bannerId = AppConfig?.AppConf?.banner_id;
			const storesApiURL = process.env.VUE_APP_STORESAPI_URL;
			const storesApiCode = process.env.VUE_APP_STORESAPI_CODE;
			if (!bannerId || !storesApiCode || !storeId) return null;

			try {
				const {data} = await axios.get(
					`${storesApiURL}/banner/${bannerId}/store/${storeId}/location?code=${storesApiCode}`
				);
				const {latitude, longitude} = data || {};
				if (latitude == null || longitude == null) return null;

				this.setCurrentLocation({latitude, longitude});
				await this.fetchFiveClosestStores();
				if (!Array.isArray(this.closestStores) || !this.closestStores.length) return null;

				return this.closestStores.find((store) => parseInt(store.storeNumber, 10) === parseInt(storeId, 10)) || this.closestStores[0];
			} catch (error) {
				console.error('Unable to resolve store data from query param storeId:', error);
				return null;
			}
		}
	},

	async created() {
		console.log("** Wrapper Created is stand along?", this.isStandAlone,  "  Route:", this.$route)
		if (this.isStandAlone) return;

		console.log("App Config Test:", AppConfig.AppConf)
		const redirect = AppConfig.AppConf?.redirect;

		if(redirect) {
			console.log("Forced Redirect Detected!!!", redirect);
			const newRoute = this.$router.resolve(merge(this.$route, redirect));

			console.log("New Route:", newRoute);
			window.location.replace(newRoute.href);
			return;
		}

		// console.log("** Wrapper Created")
		await this.getFlyersData();
		if (!this.flyers.find(flyer => flyer.title === this.$route.params.flyerId)) {
			await Rest.NavigateToFlyer(this.currentFlyer.title);
		}

		// When only storeId exists in query, resolve store details through store-locator endpoints.
		if (this.$route.query.storeId && this.storeLocatorEnabled) {
			this.setCurrentStore(parseInt(this.$route.query.storeId, 10));
			const resolvedStore = await this.fetchStoreFromQueryParamStoreId(this.$route.query.storeId);
			if (resolvedStore) {
				this.setCurrentStoreObj(resolvedStore);
			}
		}

		this.ready = true;
		window.addEventListener("resize", this.handleWindowResize);
		//this.setCurrentStore(this.$route.query.storeId);
		//const flyerId = this.$route.params.flyerId ? this.$route.params.flyerId : null;
		//await this.setCurrentFlyer(this.$route.params.flyerId);

		//await this.setPages(this.currentFlyer.title);
		//this.setLanguage()
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleWindowResize)
	}
}
</script>
